import { arrayRemove } from "../../../../../tools/lang";
import { METHOD_TEMPLATES } from "../../../utils/consts";
import { requestCgi } from "../common/requestCgi";
import { get as lodashGet } from "lodash-es";
function getUpsertMethod(cgiName, msg) {
  const fn = async function (params, args) {
    const res = await requestCgi({
      cgiName,
      params,
      instance: this,
      cgiMessage: msg
    });
    if (res.success) {
      const data = lodashGet(res.body, this.protocol.ENTITY_DATA);
      if (typeof data === 'object') {
        const index = this.listData.indexOf(args.postData);
        if (index >= 0) {
          this.listData.splice(index, 1, data);
        }
      }
    }
    return res.body;
  };
  fn.template = [cgiName === 'create' ? METHOD_TEMPLATES.list.create : METHOD_TEMPLATES.list.update];
  return fn;
}
export const create = getUpsertMethod('create', '新建成功');
export const update = getUpsertMethod('update', '更新成功');
export const get = async function get(params) {
  const res = await requestCgi({
    cgiName: 'get',
    params,
    instance: this
  });
  return res.body;
};
get.template = [METHOD_TEMPLATES.list.get];
// delete 是关键字
export const deleteMethod = async function deleteMethod(params, args) {
  await this.promiseForCollection;
  const primaryKey = this.collection.getEntityPrimaryKey();
  if (primaryKey && !args.postData[primaryKey]) {
    arrayRemove(this.listData, args.postData);
    return;
  }
  const res = await requestCgi({
    cgiName: 'delete',
    params,
    instance: this,
    cgiMessage: '删除成功'
  });
  if (res.success) {
    arrayRemove(this.selectedItems, args.postData);
    arrayRemove(this.listData, args.postData);
  }
  // 删除成功直接刷新了，组件生成适配下事件
  return res.body;
};
deleteMethod.template = [METHOD_TEMPLATES.list.delete];
//# sourceMappingURL=crud.js.map
